<template>
	<div class="d-flex">
		<b-pagination
			:value="value"
			@input="$emit('input', $event)"
			:total-rows="totalRows"
			:per-page="perPage"
		></b-pagination>
		<div class="mt-2 ml-3">
			{{
				startIndex + 1
			}}-{{
				Math.min(endIndex, totalRows)
			}} of {{
				totalRows
			}} Duplicate Groups
		</div>
	</div>
</template>

<script>
import { BPagination } from '@iebh/bootstrap-vue';
export default {
	components: {
		BPagination
	},
	props: {
		value: Number,
		totalRows: Number,
		perPage: Number,
		startIndex: Number,
		endIndex: Number
	}
}
</script>
